<template>
  <div id="app" v-title data-title="官网">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      transitionName:''
    }
  }
}
</script>

<style lang="stylus">
#app
  height 100%
  width 100%
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
</style>
